import { makeStyles } from '@material-ui/core';
import React from 'react';

import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { useScreen } from '../../../hooks/useScreen';
import { DefaultTableProps } from '../../../types/defaultTableProps';

export const useDefaultTable = ({ tableElementId }: { tableElementId: string }): DefaultTableProps => {
  const { palette } = useCustomTheme();
  const { sm } = useScreen();

  const useStyles = makeStyles({
    root: {
      '& .MuiTableCell-root': {
        paddingInline: !sm ? 12 : 6,
        paddingBlock: 8,
        '&:first-child': {
          paddingLeft: 0,
        },
      },
      '& .MuiTableRow-head': {
        verticalAlign: 'bottom',
      },
      '&. MuiButton-sizeSmall': {
        paddingInline: 2,
        minWidth: 10,
      },
    },
  });

  const stickyCellStyle = {
    position: 'sticky',
    left: 0,
    backgroundColor: palette.grey[100],
    minWidth: '60px',
    maxWidth: '120px',
    whiteSpace: 'normal',
    overflow: 'hidden',
    paddingInline: '8px',
  } as React.CSSProperties;

  const classes = useStyles();

  const table = document.getElementById(tableElementId);
  const tableClientWidth = table?.clientWidth;
  const tableScrollWidth = table?.scrollWidth;

  let isScrollable;
  if (tableClientWidth && tableScrollWidth) {
    isScrollable = tableScrollWidth > tableClientWidth;
  }

  return { classes, stickyCellStyle, isScrollable };
};
